import { useCallback } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

export const useNavigation = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  
  const workspace = searchParams.get('workspace') || ''
  const project = searchParams.get('project') || ''

  const buildNavUrl = useCallback((path) => {
    const params = new URLSearchParams()
    if (workspace) params.append('workspace', workspace)
    if (project) params.append('project', project)
    return `${path}${params.toString() ? `?${params.toString()}` : ''}`
  }, [workspace, project])

  const navigateToPage = useCallback((path) => {
    navigate(buildNavUrl(path))
  }, [buildNavUrl, navigate])

  return { navigateToPage, workspace, project }
}

